import { Grid, GridProps } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import { Switch, SwitchProps } from '../../../../atomic';
import { FormFieldWrapper } from '../shared/formFieldWrapper';
import { FormFieldProps } from './index';

type FormSwitchProps = FormFieldProps<boolean> &
  Omit<SwitchProps, 'onChange'> &
  Pick<GridProps, 'lg' | 'md' | 'sm' | 'xl' | 'xs'>;

export const FormSwitch = FormFieldWrapper<FormSwitchProps>((props) => {
  const [field] = useField<unknown>({
    name: props.name
  });
  const { setFieldValue } = useFormikContext();

  return (
    <Grid
      item
      xs={props.xs ?? 12}
      lg={props.lg}
      md={props.md}
      sm={props.sm}
      xl={props.xl}
      alignItems={'flex-end'}
      display={'flex'}
    >
      <Switch
        {...props}
        label={props.label}
        name={field.name}
        checked={!!field.value}
        onChange={(event, checked) => {
          field.onChange(event);
          props.additionalOnChange?.(checked, setFieldValue);
        }}
      />
    </Grid>
  );
}, false);
